import { ShellNavItem } from '../models/shell-nav-item';

export const nativeScreenPaths: Record<string, string> = {
  Automic: 'automic',
  AutomicExecutions: 'automic/executions',
  RepositoryQuality: 'quality-assurance/repository-quality',
  ContactSearch: 'contact-search',
  CorrelationSearch: 'correlation-search',
  MonitoredResources: 'monitored-resources',
  MonthEnd: 'month-end'
};

export function nativePathFor(screenKey: string): string | undefined {
  return nativeScreenPaths[screenKey];
}

export function moduleLinkFor(item: ShellNavItem): string[] {
  const nativePath = nativePathFor(item.screenKey);
  if (item.screenKind === 'Native' && nativePath) {
    return ['/', ...nativePath.split('/').filter((segment) => segment.length > 0)];
  }

  return ['/module', item.rowKey];
}
